import React, { useContext, useState } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import FooterInfo from "./FooterInfo";
import FooterNavigation from "./FooterNavigation";

export default function Footer() {
  const {
    strings,
    paymentCardsImage,
  } = useContext(CarOrderingContext)

  const [isOpen, setIsOpen] = useState(false)

  const close = () => setIsOpen(false)
  const open = () => setIsOpen(true)

  return (
    <footer className='config-overview-bar' open={isOpen}>
      <div className='config-overview-bar__inner config_page_container'>
        <div className='config-overview-bar__close-fields'>
          <div className='config-overview-bar__close-fields-title'>{strings.footer.overview}</div>
          <div className='config-overview-bar__close-fields-button' onClick={close}>
            {strings.footer.close}
          </div>
        </div>
        <div className='config-overview-bar__fields'>
          {typeof paymentCardsImage?.url === 'string' && (
            <div className='config-overview-bar__field'>
              <div className='payment-cards'>
                <img src={paymentCardsImage.url} alt={paymentCardsImage.alt}/>
              </div>
            </div>
          )}
          <div className='config-overview-bar__field'>
            <FooterInfo/>
          </div>
        </div>
        <div className='config-overview-bar__open-fields' onClick={open}/>

        <FooterNavigation/>
      </div>
    </footer>
  )
}
